module.exports = __webpack_public_path__ + "img/pantone-scale.1387d49a.jpg";